var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.adDefinition)?_c('GoogleAd',{attrs:{"id":_vm.adDefinition.id,"dfp-slot":_vm.adDefinition.dfpSlot,"sizes":_vm.adDefinition.sizes,"size-mapping":_vm.adDefinition.sizeMapping}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }